import { createAction, props } from '@ngrx/store';

export const toggleSideNav = createAction('[SideNav] Toggle', props<{toggle: boolean}>());

